import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { AppFacade, AuthService } from "@app/core/app-services";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(private appFacade: AppFacade, private auth: AuthService) {}

  canActivate(): boolean {
    this.appFacade
      .isAuthenticated()
      .pipe(filter((status) => status === false))
      .subscribe(() => {
        this.auth.handleAuthentication();
      });
    return true;
  }
}
